var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('legend',[_vm._v("Phone")]),_vm._v(" "),_c('form-group',{attrs:{"type":"tel","metadata":_vm.metadata[_vm.mPhoneNumber],"$v":_vm.$v[_vm.$vPhoneNumber],"addon-class":"fa-phone"},model:{value:(_vm.localPhoneNumber),callback:function ($$v) {_vm.localPhoneNumber=$$v},expression:"localPhoneNumber"}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550bfdde","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Account/PhoneNumber.vue
// module id = 191
// module chunks = 2 3 4 6